// Use this hook if you don't want/need a page refresh it will only affect the URL
import { useCallback, useMemo } from "react";

export const useNativeSearchParams = (): {
    searchParams: URLSearchParams;
    setNativeSearchParams: (key: string, value: string) => void;
    deleteNativeSearchParams: (key: string) => void;
} => {
    const currentURL = useMemo(() => new URL(window.location.href), []);
    const searchParams = useMemo(() => new URLSearchParams(currentURL.search), [currentURL]);

    const updateURL = useCallback(() => {
        window.history.replaceState(
            {},
            "",
            `${window.location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`,
        );
    }, [searchParams]);

    const setNativeSearchParams = useCallback(
        (key: string, value: string) => {
            searchParams.set(key, value);
            setTimeout(updateURL, 0);
        },
        [searchParams, updateURL],
    );

    const deleteNativeSearchParams = useCallback(
        (key: string) => {
            searchParams.delete(key);
            setTimeout(updateURL, 0);
        },
        [searchParams, updateURL],
    );

    return {
        searchParams,
        setNativeSearchParams,
        deleteNativeSearchParams,
    };
};
